<template>
    <article class="post-article-block block" :class="['type-'+ data.type, {'list-type' : list}]" v-if="data">
        <WpLink class="post-link" :url="data.link" :title="data.title">
            <div class="top-item">
                <WpImage size="medium_large" class="featured" v-if="data.featured_image" :image="data.featured_image" cover background />
                <div v-else class="featured dummy-image"><div class="img"></div></div>
                <div class="cat-label" v-if="data.acf.category && data.acf.category.length">
                    <span class="jost--14" v-for="({id, name}) in data.acf.category" :key="id">{{name}}<i class="sep">,</i></span>
                </div>
            </div>

            <div class="inner">
                <h3 class="titler jost jost--30 font--500">{{data.title}}</h3>
            </div>
        </WpLink>
    </article>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import WpLink from '@/components/elements/WpLink'

import { mapGetters } from 'vuex';

export default {
    name: 'post-block', 
    props: {
        data: {
            type: Object,
            default: {},
        },
        list: {
            type: Boolean,
            default: false,
        },
    },
    data(){
        return {
        }
    },
    components:{
        WpImage,
        WpLink
    },
    computed:{
        ...mapGetters([
            'storedTaxonomy'
        ]),
    },
    mounted(){
    }

};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.post-article-block{
    &.list-type{
        .post-link{
            width: 100%;
            display: flex;
            flex-direction: row;
            background-color: $dark;
            min-height: 215px;
             .wp-image-vue{
                max-width: 50%; 
                min-width: 50%;
                padding-right: 25px;
                @include mquery($tablet){
                    padding-right: 15px;
                }
                .image{
                    padding-bottom: 0;
                    height: 100%;
                }
             }
             .inner{
                color: #fff;
                padding: 25px;
                padding-right: 50px;
                display: flex;
                align-items: center;
                @include mquery($tablet){
                    padding: 15px;
                    padding-right: 25px;
                }
             }
            
            @include mquery($phone){
                flex-direction: column;
                .wp-image-vue{
                    min-width: 100%;
                    max-width: 100%;
                    min-height: 250px;;
                    padding-right: 0;
                    .image{
                        padding-bottom: 56.4%;
                        height: 0;
                    }
                }
                .inner{
                    padding: 25px;
                }


            }
        }

    }
    .top-item{
        position: relative;
        .cat-label{
            position: absolute;
            left: 0;
            bottom: 0;
            padding: 5px 10px;
            background-color: $blue;
            color: #fff;
            line-height: 1;
            span{
                display: block;
                &:last-child{
                    .sep{
                        display: none
                    }
                }
            }
        }
    }
    .wp-image-vue .image{
        @include transition(opacity , 0.15s);
    }
    .post-link{
        background-color: #fff;
        display: block;
        text-decoration: none;
        overflow: hidden;
        height: 100%;
        display: flex;
        line-height: 1.33;
        flex-direction: column;
        transition: 0.2s background-color ease-in-out;
        &:hover{
            .wp-image-vue .image{
                opacity: 0.75 !important;
            }
        }
        .titler{
            margin: 0;
        }
        .inner{
            padding: 25px 0px;
            position: relative;
        }
    }
    .dummy-image .img{
        border-radius: $radius;
        height: 0;
        background-color: #dedede;
        padding-bottom: 56.4%;
    }
}
</style>